import PropTypes from 'prop-types';

function StatRow({ label, data }) {
  return (
    <div className="flex items-center justify-between text-sm text-gray-200">
      <div className="text-gray-400">{label}</div>
      <div className="flex items-center gap-3">
        <span className="text-green-200">W {data.wins || 0}</span>
        <span className="text-red-200">L {data.losses || 0}</span>
        <span className="text-yellow-200">Flat {data.flats || 0}</span>
        <span className="text-gray-300">Raw avg {Number(data.avg_pnl || 0).toFixed(2)}%</span>
      </div>
    </div>
  );
}

export default function StrategyWinLossPanel({ stats }) {
  const perEngine = Object.entries(stats?.per_engine || {});
  const perCoin = Object.entries(stats?.per_coin || {});

  return (
    <div className="rounded-2xl border border-gray-800 bg-gray-900/70 p-4 space-y-4" data-testid="win-loss-panel">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-[0.65rem] uppercase tracking-wide text-gray-500">Raw trade-log telemetry</p>
          <h3 className="text-lg font-semibold text-white">Win / Loss Inventory</h3>
          <p className="text-xs text-amber-100">Not clean measurement evidence; no profitability conclusion.</p>
        </div>
        <div className="text-xs text-gray-400">Totals: {stats?.totals?.wins || 0}W / {stats?.totals?.losses || 0}L</div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <div className="text-xs uppercase text-gray-500 tracking-wide">By Engine</div>
          {perEngine.length === 0 && <div className="text-sm text-gray-500">No trades yet.</div>}
          {perEngine.map(([engine, data]) => (
            <StatRow key={engine} label={engine.toUpperCase()} data={data} />
          ))}
        </div>
        <div className="space-y-2">
          <div className="text-xs uppercase text-gray-500 tracking-wide">By Coin</div>
          {perCoin.length === 0 && <div className="text-sm text-gray-500">No coin activity recorded.</div>}
          {perCoin.map(([coin, data]) => (
            <StatRow key={coin} label={coin.toUpperCase()} data={data} />
          ))}
        </div>
      </div>
    </div>
  );
}

StatRow.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
};

StrategyWinLossPanel.propTypes = {
  stats: PropTypes.object,
};
